import { createContext, useContext, useEffect } from 'react';
import { PageTour, TourRole } from './tours';

export interface TourContextValue {
  /** Tour for the current page, if it has one. */
  tour: PageTour | null;
  /** This browser has finished the current page's tour before. */
  explored: boolean;
  setPageRole: (role: TourRole | null) => void;
  active: boolean;
  start: () => void;
  /** Header and toolbar buttons register so the floating button only shows where there is none. */
  registerInlineButton: () => () => void;
}

export const TourContext = createContext<TourContextValue | null>(null);

/** Null outside a TourProvider (e.g. component tests), so the tour button simply doesn't render. */
export const useTour = () => useContext(TourContext);

/** A page reports the viewer's role on it, so Explore shows that role's tour. */
export function useTourRole(role: TourRole | null) {
  const setPageRole = useContext(TourContext)?.setPageRole;
  useEffect(() => {
    if (!setPageRole) return undefined;
    setPageRole(role);
    return () => setPageRole(null);
  }, [role, setPageRole]);
}
